/**
 * Created by Arokoyu Olalekan Ojo
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {IResponse} from '../../interfaces/iresponse';
import {ApiService} from '../api/api.service.';
// import {DecryptService} from '../../decryptService/decrypt.service';
@Injectable()
export class UserService {

  constructor(private api: ApiService) {

  }
  createFolder(data): Observable<IResponse> {
    return this.api.postRequest('document', 'folders' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  forwardDocumentUsers(data): Observable<IResponse> {
    return this.api.postRequest('document', 'users/share' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  forwardFolderUsers(data): Observable<IResponse> {
    return this.api.postRequest('folder', 'users/share' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  forwardDocumentUnits(data): Observable<IResponse> {
    return this.api.postRequest('document', 'share' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  forwardFolderUnits(data): Observable<IResponse> {
    return this.api.postRequest('folder', 'share' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  createWordDocument(data): Observable<IResponse> {
    return this.api.postRequest('documents', null, data).map((res: IResponse)  => {
      return res ;
    });
  }
  updateWordDocument(data, documentId): Observable<IResponse> {
    return this.api.postRequest('documents/'+ documentId, null, data).map((res: IResponse)  => {
      return res ;
    });
  }
  createUser(data): Observable<IResponse> {
    return this.api.postRequest('users', 'store' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  updateUser(data): Observable<IResponse> {
    return this.api.patchRequest('users', 'update' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  deactivateUser(data): Observable<IResponse> {
    return this.api.patchRequest('users', 'deactivate-user' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  reactivateUser(data): Observable<IResponse> {
    return this.api.patchRequest('users', 'activate-user' , data).map((res: IResponse)  => {
      return res ;
    });
  }
  globalSearch(data): Observable<IResponse> {
    return this.api.getRequest('search', 'documents?key=' + data.key).map((res: IResponse)  => {
      return res ;
    });
  }
  advanceSearch(data): Observable<IResponse> {
    return this.api.postRequest('advanced_search', null, data).map((res: IResponse)  => {
      return res ;
    });
  }
  updateFolder(data, folder_id): Observable<IResponse> {
    return this.api.patchRequest('document', 'folders/' + folder_id , data).map((res: IResponse)  => {
      return res ;
    });
  }

  public updatePassword(data): Observable<IResponse> {
    return this.api.postRequest('auth/password', 'settings', data).map( (res: IResponse) => {
      return res;
    });
  }
  restoreFolder(folder_ids): Observable<IResponse> {
    return this.api.postRequest('document', 'folders/restore' , folder_ids).map((res: IResponse)  => {
      return res ;
    });
  }
  restoreDocument(document_ids): Observable<IResponse> {
    return this.api.postRequest('documents', 'restore' , document_ids).map((res: IResponse)  => {
      return res ;
    });
  }
  deleteFolder(folder_id): Observable<IResponse> {
    return this.api.deleteRequest('document', 'folders/' + folder_id ).map((res: IResponse)  => {
      return res ;
    });
  }
  deleteDocument(document_id): Observable<IResponse> {
    return this.api.deleteRequest('documents', document_id ).map((res: IResponse)  => {
      return res ;
    });
  }
  public getPaymentChannels(can_fund = false): Observable<IResponse> {
    if (can_fund) {
      return this.api.getRequest('payment-channel?can_fund_wallet=true', null).map( (res: IResponse) => {
        return res;
      });
    } else {
      return this.api.getRequest('payment-channel', null).map( (res: IResponse) => {
        return res;
      });
    }
  }
  public getFolderForParentDirectory(param): Observable<IResponse> {
    return this.api.getRequest('documents', 'by/folders', param).map( (res: IResponse) => {
      return res;
    });
  }
  public getMostRecent(): Observable<IResponse> {
    return this.api.getRequest('documents', 'my/latest/5').map( (res: IResponse) => {
      return res;
    });
  }
  public getTemplates(): Observable<IResponse> {
    return this.api.getRequest('templates', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getWorkflows(): Observable<IResponse> {
    return this.api.getRequest('workflowconfig', null).map( (res: IResponse) => {
      return res;
    });
  }
  public get2Factor(): Observable<IResponse> {
    return this.api.getRequest('google2FA', 'returncodeQR').map( (res: IResponse) => {
      return res;
    });
  }
  public complete2Factor(data): Observable<IResponse> {
    return this.api.postRequest('google2FA', 'confirmcodeQR', data).map( (res: IResponse) => {
      return res;
    });
  }
  public getCategoryAccess(catId): Observable<IResponse> {
    return this.api.getRequest('category/roleaccess', 'levels/' + catId).map( (res: IResponse) => {
      return res;
    });
  }
  public createCategoryAccess(data): Observable<IResponse> {
    return this.api.postRequest('category/roleaccess', 'level', data).map( (res: IResponse) => {
      return res;
    });
  }
  public takeActionOnDocumentNow(data, workflow_id): Observable<IResponse> {
    return this.api.patchRequest('workflowvalue', workflow_id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public getTemplate(id): Observable<IResponse> {
    return this.api.getRequest('templates', id).map( (res: IResponse) => {
      return res;
    });
  }
  public deleteTemplate(id): Observable<IResponse> {
    return this.api.deleteRequest('templates', id).map( (res: IResponse) => {
      return res;
    });
  }
  public deleteWorkflow(id): Observable<IResponse> {
    return this.api.deleteRequest('workflowconfig', id).map( (res: IResponse) => {
      return res;
    });
  }
  public deleteDocumentAccess(id): Observable<IResponse> {
    return this.api.deleteRequest('category/roleaccess', id).map( (res: IResponse) => {
      return res;
    });
  }
  public createWorkFlow(data): Observable<IResponse> {
    return this.api.postRequest('workflowconfig', null, data).map( (res: IResponse) => {
      return res;
    });
  }
  public createTemplate(data): Observable<IResponse> {
    return this.api.postRequest('templates', null, data).map( (res: IResponse) => {
      return res;
    });
  }
  public createDocumentUsingTemplate(data): Observable<IResponse> {
    return this.api.postRequest('template_values', 'document', data).map( (res: IResponse) => {
      return res;
    });
  }
  public patchTemplate(data, id): Observable<IResponse> {
    return this.api.patchRequest('templates', id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public patchWorkflow(data, id): Observable<IResponse> {
    return this.api.patchRequest('workflowconfig', id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public getTrash(): Observable<IResponse> {
    return this.api.getRequest('document', 'folders/mytrash').map( (res: IResponse) => {
      return res;
    });
    // return this.api.getRequest('document', 'folders/alltrashitems').map( (res: IResponse) => {
    //   return res;
    // });
  }
  public getFolderContent(parent_folder): Observable<IResponse> {
    return this.api.getRequest('documents', 'by/folders?parent=' + parent_folder).map( (res: IResponse) => {
      return res;
    });
  }
  public getSubDocuments(parent_folder): Observable<IResponse> {
    return this.api.getRequest('documents?parent=' + parent_folder, null).map( (res: IResponse) => {
      return res;
    });
  }
  public getDocumentForDirectory(): Observable<IResponse> {
    return this.api.getRequest('documents', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getDocument(doc_id): Observable<IResponse> {
    return this.api.getRequest('documents', doc_id).map( (res: IResponse) => {
      return res;
    });
  }
  public getNextAction(doc_id, user_id): Observable<IResponse> {
    return this.api.getRequest('getworkflowaction/'+doc_id, user_id).map( (res: IResponse) => {
      return res;
    });
  }
  public restoreVersion(doc_id, version_id): Observable<IResponse> {
    return this.api.getRequest('documents/version/revert/' + doc_id, version_id).map( (res: IResponse) => {
      return res;
    });
  }
  public getDocumentVersion(doc_id): Observable<IResponse> {
    return this.api.getRequest('documents/versions', doc_id).map( (res: IResponse) => {
      return res;
    });
  }
  public getDocumentShareRight(doc_id): Observable<IResponse> {
    return this.api.getRequest('document/rights', doc_id).map( (res: IResponse) => {
      return res;
    });
  }
  public getDocumentType(id): Observable<IResponse> {
    return this.api.getRequest('document/types', id).map( (res: IResponse) => {
      return res;
    });
  }
 }
